export default "__VITE_ASSET__B3pBOTdc__"